module.exports = __webpack_public_path__ + "edu-logo.svg?9f3ab47dc648520ebf94454c01448551";